import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  actionTypes,
  deleteExtFieldsFailure,
  deleteExtFieldsSuccess,
  deleteServiceReqFailure,
  deleteServiceReqFieldsFailure,
  deleteServiceReqFieldsSuccess,
  deleteServiceReqSuccess,
  deleteTemplateTicketFailure,
  deleteTemplateTicketFieldsFailure,
  deleteTemplateTicketFieldsSuccess,
  deleteTemplateTicketSuccess,
  getExternalFieldsFailure,
  getExternalFieldsSuccess,
  getFieldsTypeFailure,
  getFieldsTypeSuccess,
  getServiceReqFailure,
  getServiceReqFieldsFailure,
  getServiceReqFieldsSuccess,
  getServiceReqSuccess,
  getTemplateTicketFailure,
  getTemplateTicketFieldsFailure,
  getTemplateTicketFieldsSuccess,
  getTemplateTicketSuccess,
  postExtFieldsFailure,
  postExtFieldsSuccess,
  postServiceReqFailure,
  postServiceReqFieldsFailure,
  postServiceReqFieldsSuccess,
  postServiceReqSuccess,
  postTemplateTicketFailure,
  postTemplateTicketFieldsFailure,
  postTemplateTicketFieldsSuccess,
  postTemplateTicketSuccess,
} from "./actions";
import {
  getTemplateTicket,
  getTemplateTicketFields,
  getServiceReq,
  getServiceReqFields,
  getExternalFields,
  postTemplateTicket,
  deleteTemplateTicket,
  postTemplateTicketFields,
  deleteTemplateTicketFields,
  postServiceRequest,
  deleteServiceRequest,
  postServiceReqFields,
  deleteServiceReqFields,
  postExtFields,
  deleteExtFields,
  getFieldsType,
} from "./services";

const fetchFieldTypeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_FIELDS_TYPE),
    mergeMap(() =>
      getFieldsType().pipe(
        map((res: any) => getFieldsTypeSuccess(res)),
        catchError((error: any) => of(getFieldsTypeFailure(error)))
      )
    )
  );

const fetchGetTemplateTicketEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_TEMPLATE_T),
    mergeMap(() =>
      getTemplateTicket().pipe(
        map((response: any) => getTemplateTicketSuccess(response)),
        catchError((error: any) => of(getTemplateTicketFailure(error)))
      )
    )
  );

const postTemplateTicketEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_TEMPLATE_T),
    mergeMap((action: any) =>
      postTemplateTicket(action.payload).pipe(
        map((response: any) => postTemplateTicketSuccess(response)),
        catchError((error: any) => of(postTemplateTicketFailure(error)))
      )
    )
  );

const deleteTemplateTicketEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_TEMPLATE_T),
    mergeMap((action: any) =>
      deleteTemplateTicket(action.payload).pipe(
        map((response: any) => deleteTemplateTicketSuccess(response)),
        catchError((error: any) => of(deleteTemplateTicketFailure(error)))
      )
    )
  );

const fetchGetTemplateTicketFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_TEMPLATE_FIELDS),
    mergeMap(() =>
      getTemplateTicketFields().pipe(
        map((response: any) => getTemplateTicketFieldsSuccess(response)),
        catchError((error: any) => of(getTemplateTicketFieldsFailure(error)))
      )
    )
  );

const postTemplateTicketFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_TEMPLATE_FIELDS),
    mergeMap((action: any) =>
      postTemplateTicketFields(action.payload).pipe(
        map((response: any) => postTemplateTicketFieldsSuccess(response)),
        catchError((error: any) => of(postTemplateTicketFieldsFailure(error)))
      )
    )
  );

const deleteTemplateTicketFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_TEMPLATE_FIELDS),
    mergeMap((action: any) =>
      deleteTemplateTicketFields(action.payload).pipe(
        map((response: any) => deleteTemplateTicketFieldsSuccess(response)),
        catchError((error: any) => of(deleteTemplateTicketFieldsFailure(error)))
      )
    )
  );

const fetchGetServiceReqEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SERV),
    mergeMap(() =>
      getServiceReq().pipe(
        map((response: any) => getServiceReqSuccess(response)),
        catchError((error: any) => of(getServiceReqFailure(error)))
      )
    )
  );

const postServiceRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_SERV),
    mergeMap((action: any) =>
      postServiceRequest(action.payload).pipe(
        map((response: any) => postServiceReqSuccess(response)),
        catchError((error: any) => of(postServiceReqFailure(error)))
      )
    )
  );

const deleteServiceRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_SERV),
    mergeMap((action: any) =>
      deleteServiceRequest(action.payload).pipe(
        map((response: any) => deleteServiceReqSuccess(response)),
        catchError((error: any) => of(deleteServiceReqFailure(error)))
      )
    )
  );

const fetchGetServiceReqFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SERV_FIELDS),
    mergeMap(() =>
      getServiceReqFields().pipe(
        map((response: any) => getServiceReqFieldsSuccess(response)),
        catchError((error: any) => of(getServiceReqFieldsFailure(error)))
      )
    )
  );

const postServiceReqFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_SERV_FIELDS),
    mergeMap((action: any) =>
      postServiceReqFields(action.payload).pipe(
        map((response: any) => postServiceReqFieldsSuccess(response)),
        catchError((error: any) => of(postServiceReqFieldsFailure(error)))
      )
    )
  );

const deleteServiceReqFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_SERV_FIELDS),
    mergeMap((action: any) =>
      deleteServiceReqFields(action.payload).pipe(
        map((response: any) => deleteServiceReqFieldsSuccess(response)),
        catchError((error: any) => of(deleteServiceReqFieldsFailure(error)))
      )
    )
  );

const fetchGetExternalFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_EXTERNAL_FIELDS),
    mergeMap(() =>
      getExternalFields().pipe(
        map((response: any) => getExternalFieldsSuccess(response)),
        catchError((error: any) => of(getExternalFieldsFailure(error)))
      )
    )
  );

const postExtFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_EXT_FIELDS),
    mergeMap((action: any) =>
      postExtFields(action.payload).pipe(
        map((response: any) => postExtFieldsSuccess(response)),
        catchError((error: any) => of(postExtFieldsFailure(error)))
      )
    )
  );

const deleteExtFieldsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_EXT_FIELDS),
    mergeMap((action: any) =>
      deleteExtFields(action.payload).pipe(
        map((response: any) => deleteExtFieldsSuccess(response)),
        catchError((error: any) => of(deleteExtFieldsFailure(error)))
      )
    )
  );

export default [
  fetchFieldTypeEpic,
  fetchGetTemplateTicketEpic,
  postTemplateTicketEpic,
  deleteTemplateTicketEpic,
  fetchGetTemplateTicketFieldsEpic,
  postTemplateTicketFieldsEpic,
  deleteTemplateTicketFieldsEpic,
  fetchGetServiceReqEpic,
  postServiceRequestEpic,
  deleteServiceRequestEpic,
  fetchGetServiceReqFieldsEpic,
  postServiceReqFieldsEpic,
  deleteServiceReqFieldsEpic,
  fetchGetExternalFieldsEpic,
  postExtFieldsEpic,
  deleteExtFieldsEpic,
];
